import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: row;
  ${({ borderWidth, borderColor }) =>
    borderWidth &&
    `border-width: ${borderWidth};
    border-style: solid;
    border-color: ${borderColor || 'black'};`}
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
  ${({ flex }) => flex && `flex: ${flex};`}
`;
